export const root = '@container/carousel';

export const item = [
  'basis-[90%]', // 1 in view, 1 partially
  '@xs/carousel:basis-[45%]', // 320px+ 2 in view, 1 partially
  '@xl/carousel:basis-1/3', // 576px+ 3 in view
  '@3xl/carousel:basis-1/4', // 1024px+ 4 in view
  '@7xl/carousel:basis-1/5' // 1280px+ 5 in view
];

export const baseButton = [
  'rounded-lg bg-[#fff]/70 p-3 shadow-[4px_8px_8px_0px_rgba(0,0,0,0.04)] transition-colors zappos:rounded-sm zappos:bg-gray-0 zappos:px-0 zappos:py-[10px]', // base
  'hover:bg-button-hover hover:text-icon-reversed zappos:hover:bg-gray-900 zappos:hover:text-gray-0', // hover
  'active:bg-button-primary active:shadow-none zappos:active:bg-gray-500 zappos:active:text-gray-0', // active
  'sm:block hidden data-[can-scroll=false]:hidden' // conditional show/hide ( mobile hide )
];

export const backButton = [...baseButton, 'absolute left-4 top-1/2 -translate-y-1/2 zappos:-left-4 zappos:top-1/3'];

export const forwardButton = [...baseButton, 'absolute right-4 top-1/2 -translate-y-1/2 zappos:-right-4 zappos:top-1/3'];
